import React from "react";
import { motion } from "framer-motion";
import { CHAPTERS } from "@/lib/brand";
import { Reveal, SectionLabel } from "@/components/Motion";

const Chapter = ({ c, i }) => (
  <motion.article
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-10% 0px -10% 0px" }}
    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
    data-testid={`chapter-${c.n}`}
    className="group relative grid gap-6 border-t border-white/8 py-12 lg:grid-cols-12 lg:gap-10 lg:py-16"
  >
    <span className="pointer-events-none absolute inset-x-0 -top-px h-px origin-left scale-x-0 bg-[hsl(var(--orv-blue))]/60 transition-transform duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-x-100" />

    <div className="lg:col-span-2">
      <div className="font-display text-5xl font-extrabold leading-none text-white/10 transition-colors duration-500 group-hover:text-[hsl(var(--orv-blue))]/45 lg:text-6xl">
        {c.n}
      </div>
      <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.22em] text-white/40">
        {c.kicker}
      </div>
    </div>

    <div className="lg:col-span-5">
      <h3 className="font-display text-2xl font-bold uppercase leading-[1.08] tracking-tight text-white sm:text-3xl">
        {c.title}
      </h3>
      <div className="mt-5 flex flex-wrap gap-2">
        {c.tags.map((t) => (
          <span
            key={t}
            className="border border-white/10 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.12em] text-white/45 transition-colors duration-300 group-hover:border-white/22 group-hover:text-white/65"
          >
            {t}
          </span>
        ))}
      </div>
    </div>

    <div className="lg:col-span-5">
      <p className="text-sm leading-[1.85] text-white/50">{c.body}</p>
    </div>
  </motion.article>
);

export const Features = () => (
  <section id="features" className="relative border-b border-white/8 py-24 lg:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid gap-10 pb-14 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <SectionLabel index="§ 03">Inside Fight Studio v4.2.0</SectionLabel>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display text-[clamp(2rem,4.6vw,3.6rem)] font-extrabold uppercase leading-[0.96] tracking-[-0.015em] text-white">
              Eleven systems.
              <br />
              <span className="text-white/35">One resource folder.</span>
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-5 lg:pb-3">
          <Reveal delay={0.12}>
            <p className="text-sm leading-relaxed text-white/45">
              This isn't an animation menu with a play button bolted on. It's a full choreography
              suite — a 262-animation library, guided lineup, frame-level contact matching, a
              sequence builder, a built-in character editor, spectators and support for your own
              .ycd animations. Standalone, with no framework and no database.
            </p>
          </Reveal>
        </div>
      </div>

      <div>
        {CHAPTERS.map((c, i) => (
          <Chapter key={c.n} c={c} i={i} />
        ))}
      </div>
      <div className="h-px w-full bg-white/8" />
    </div>
  </section>
);
